import React from 'react';
import { number, func, bool } from 'prop-types';
import { connect } from 'react-redux';

import NavLink from '../components/common/NavLink';
import * as urls from '../actions/urlTypes';
import { resetState, getIEInitialData } from '../actions/turnkeyOmnibusActions';
import { isFeaturePresent } from '../util/CommonUtils';
import { TURNKEY_OMNIBUS_FEATUREID } from '../constants';

const OmnibusNav = ({
  activeAccountId,
  resetState,
  getIEInitialData,
  impersonated,
  isQtsEnabled,
}) => {
  const _clearAllData = () => {
    resetState(true);
    if (!impersonated && isQtsEnabled) {
      getIEInitialData(activeAccountId);
    }
  };
  return (
    <nav className="nav-dropdown-menu--items">
      <ul className="nav-dropdown-menu--list">
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={urls.PREMIER_OMNIBUS_URL}
          >
            Premier Omnibus
          </a>
        </li>

        <li onClick={_clearAllData}>
          <NavLink to={`${urls.APP_ROOT_URL}/omnibus/turnkey`}>
            Turn-Key Omnibus
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

OmnibusNav.propTypes = {
  resetState: func.isRequired,
  getIEInitialData: func,
  activeAccountId: number.isRequired,
  isQtsEnabled: bool,
  impersonated: bool,
};

OmnibusNav.defaultProps = {
  isQtsEnabled: true,
  impersonated: false,
};

const mapStateToProps = ({ account, login, userDetail }) => {
  return {
    impersonated: login.loginResponse.data.impersonated,
    isQtsEnabled: isFeaturePresent(
      TURNKEY_OMNIBUS_FEATUREID,
      userDetail.permissions
    ),
    activeAccountId: account.activeAccountId,
  };
};

export default connect(mapStateToProps, {
  resetState,
  getIEInitialData,
})(OmnibusNav);
